module.exports = __webpack_public_path__ + "Roboto-LightItalic.woff2";